module.exports = __webpack_public_path__ + "9e62215b623a6317bd37677e296d8b1f.jpg";